/**
 * Yahoo team-defense/special-teams entries are draftable roster units, not
 * individual players. They remain in the canonical Draft Lab catalog for the
 * Standard Draft, but they are never valid commissioner-added keeper
 * eligibles. Individual defensive players (DI/ED/LB/CB/S/DB) remain valid.
 */
export function isTeamDefensePlayer(
  player: { id?: string | null; name?: string | null; positions?: readonly string[] | null },
): boolean {
  const positions = player.positions ?? [];
  return positions.some((position) => {
    const normalized = String(position).trim().toUpperCase().replace(/\s+/gu, "");
    return normalized === "DEF"
      || normalized === "DST"
      || normalized === "D/ST"
      || normalized === "ST";
  });
}

export function isKeeperEligibilityPlayer(
  player: { id?: string | null; name?: string | null; positions?: readonly string[] | null },
): boolean {
  return !isTeamDefensePlayer(player);
}
